// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../types/schema';

import { EntityDiagram_EntityDiagramFragment } from './EntityDiagram.generated';
import { GetTaxStatusForEntity_EntityFragment } from '../../content/sidebarContent/dispositiveProvisionsRecipientType/graphql/GetTaxStatusForEntity.generated';
import { gql } from '@apollo/client';
import { EntityDiagram_EntityDiagramFragmentDoc } from './EntityDiagram.generated';
import { GetTaxStatusForEntity_EntityFragmentDoc } from '../../content/sidebarContent/dispositiveProvisionsRecipientType/graphql/GetTaxStatusForEntity.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type QprtTermDiagram_EntityFragment = { __typename?: 'Entity', id: string, extendedDisplayKind: string, stage: Types.EntityStage, entityKind: Types.EntityKind, household: { __typename?: 'Household', id: string }, entityDiagrams: { __typename?: 'EntityDiagramConnection', edges?: Array<{ __typename?: 'EntityDiagramEdge', node?: (
        { __typename?: 'EntityDiagram' }
        & EntityDiagram_EntityDiagramFragment
      ) | null } | null> | null }, subtype: { __typename?: 'CCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'CLTTrust', id: string, displayName: string } | { __typename?: 'CRTTrust', id: string, displayName: string } | { __typename?: 'CustodialPersonalAccount', id: string, displayName: string } | { __typename?: 'DonorAdvisedFund', id: string, displayName: string } | { __typename?: 'GPBusinessEntity', id: string, displayName: string } | { __typename?: 'GRATTrust', id: string, displayName: string } | { __typename?: 'ILITTrust', id: string, displayName: string } | { __typename?: 'IndividualPersonalAccount', id: string, displayName: string } | { __typename?: 'InsurancePersonalAccount', id: string, displayName: string } | { __typename?: 'IrrevocableTrust', id: string, displayName: string } | { __typename?: 'JointPersonalAccount', id: string, displayName: string } | { __typename?: 'LLCBusinessEntity', id: string, displayName: string } | { __typename?: 'LPBusinessEntity', id: string, displayName: string } | { __typename?: 'PrivateFoundation', id: string, displayName: string } | { __typename?: 'QPRTTrust', termEndDate?: Time | null, inEstateStatus: Types.EntityInEstateStatus, id: string, displayName: string, grantors?: Array<{ __typename?: 'Principal', id: string, individual?: { __typename?: 'ClientProfile', id: string, displayName: string } | null }> | null, beneficiaries?: Array<{ __typename?: 'Beneficiary', id: string, individual?: { __typename?: 'ClientProfile', id: string, displayName: string } | null, organization?: { __typename?: 'ClientOrganization', id: string, name: string } | null, entity?: (
        { __typename?: 'Entity', id: string, extendedDisplayKind: string, entityKind: Types.EntityKind, subtype: { __typename?: 'CCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'CLTTrust', id: string, displayName: string } | { __typename?: 'CRTTrust', id: string, displayName: string } | { __typename?: 'CustodialPersonalAccount', id: string, displayName: string } | { __typename?: 'DonorAdvisedFund', id: string, displayName: string } | { __typename?: 'GPBusinessEntity', id: string, displayName: string } | { __typename?: 'GRATTrust', id: string, displayName: string } | { __typename?: 'ILITTrust', id: string, displayName: string } | { __typename?: 'IndividualPersonalAccount', id: string, displayName: string } | { __typename?: 'InsurancePersonalAccount', id: string, displayName: string } | { __typename?: 'IrrevocableTrust', id: string, displayName: string } | { __typename?: 'JointPersonalAccount', id: string, displayName: string } | { __typename?: 'LLCBusinessEntity', id: string, displayName: string } | { __typename?: 'LPBusinessEntity', id: string, displayName: string } | { __typename?: 'PrivateFoundation', id: string, displayName: string } | { __typename?: 'QPRTTrust', id: string, displayName: string } | { __typename?: 'QualifiedTuitionPersonalAccount', id: string, displayName: string } | { __typename?: 'RetirementPersonalAccount', id: string, displayName: string } | { __typename?: 'RevocableTrust', id: string, displayName: string } | { __typename?: 'SCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'SLATTrust', id: string, displayName: string } | { __typename?: 'SoleProprietorshipBusinessEntity', id: string, displayName: string } }
        & GetTaxStatusForEntity_EntityFragment
      ) | null }> | null } | { __typename?: 'QualifiedTuitionPersonalAccount', id: string, displayName: string } | { __typename?: 'RetirementPersonalAccount', id: string, displayName: string } | { __typename?: 'RevocableTrust', id: string, displayName: string } | { __typename?: 'SCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'SLATTrust', id: string, displayName: string } | { __typename?: 'SoleProprietorshipBusinessEntity', id: string, displayName: string } };

export type QprtTermDiagramQueryVariables = Types.Exact<{
  entityWhere: Types.EntityWhereInput;
}>;


export type QprtTermDiagramQuery = { __typename?: 'Query', entities: { __typename?: 'EntityConnection', edges?: Array<{ __typename?: 'EntityEdge', node?: (
        { __typename?: 'Entity' }
        & QprtTermDiagram_EntityFragment
      ) | null } | null> | null } };

export const Operations = {
  Query: {
    QprtTermDiagram: 'QprtTermDiagram' as const
  },
  Fragment: {
    QprtTermDiagram_Entity: 'QprtTermDiagram_Entity' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const QprtTermDiagram_EntityFragmentDoc = gql`
    fragment QprtTermDiagram_Entity on Entity {
  id
  entityKind: kind
  extendedDisplayKind
  stage
  household {
    id
  }
  entityDiagrams(where: {kind: QPRT_TERM}) {
    edges {
      node {
        ...EntityDiagram_EntityDiagram
      }
    }
  }
  subtype {
    id
    displayName
    ... on QPRTTrust {
      termEndDate
      grantors {
        id
        individual {
          id
          displayName
        }
      }
      beneficiaries {
        id
        individual {
          id
          displayName
        }
        organization {
          id
          name
        }
        entity {
          id
          entityKind: kind
          extendedDisplayKind
          subtype {
            id
            displayName
          }
          ...GetTaxStatusForEntity_Entity
        }
      }
      inEstateStatus
    }
  }
}
    ${EntityDiagram_EntityDiagramFragmentDoc}
${GetTaxStatusForEntity_EntityFragmentDoc}`;
export const QprtTermDiagramDocument = gql`
    query QprtTermDiagram($entityWhere: EntityWhereInput!) {
  entities(where: $entityWhere) {
    edges {
      node {
        ...QprtTermDiagram_Entity
      }
    }
  }
}
    ${QprtTermDiagram_EntityFragmentDoc}`;

/**
 * __useQprtTermDiagramQuery__
 *
 * To run a query within a React component, call `useQprtTermDiagramQuery` and pass it any options that fit your needs.
 * When your component renders, `useQprtTermDiagramQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQprtTermDiagramQuery({
 *   variables: {
 *      entityWhere: // value for 'entityWhere'
 *   },
 * });
 */
export function useQprtTermDiagramQuery(baseOptions: Apollo.QueryHookOptions<QprtTermDiagramQuery, QprtTermDiagramQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QprtTermDiagramQuery, QprtTermDiagramQueryVariables>(QprtTermDiagramDocument, withFetchPolicyContext(options));
      }
export function useQprtTermDiagramLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QprtTermDiagramQuery, QprtTermDiagramQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QprtTermDiagramQuery, QprtTermDiagramQueryVariables>(QprtTermDiagramDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useQprtTermDiagramSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QprtTermDiagramQuery, QprtTermDiagramQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QprtTermDiagramQuery, QprtTermDiagramQueryVariables>(QprtTermDiagramDocument, withFetchPolicyContext(options));
        }
export type QprtTermDiagramQueryHookResult = ReturnType<typeof useQprtTermDiagramQuery>;
export type QprtTermDiagramLazyQueryHookResult = ReturnType<typeof useQprtTermDiagramLazyQuery>;
export type QprtTermDiagramSuspenseQueryHookResult = ReturnType<typeof useQprtTermDiagramSuspenseQuery>;
export type QprtTermDiagramQueryResult = Apollo.QueryResult<QprtTermDiagramQuery, QprtTermDiagramQueryVariables>;